<template>
    <div class='home-page'>
        <div class='carousel'>
            <Carousel v-model="carouselIndex" :loop='carouselImages.length > 1' :autoplay='carouselImages.length > 1' arrow='never' :autoplay-speed='5000'>
                <CarouselItem v-for='item in carouselImages' autoplay :key='"car-it-" + item.uuid'>
                    <div class="h-carousel-item cFlex">
                        <img class="h-carousel-img" :src="slideshowIp+'static/file/'+item.remark.diskFileName">
                    </div>
                </CarouselItem>
            </Carousel>
            <div class="h-login-wrapper">
                <div class="h-login-top ajFlex">
                    <div class="h-login-item"
                         v-for="(item,index) in common.userTypes" :key="index"
                         :class="{active:formLogin.loginType===item.value}"
                            @click="formLogin.loginType = item.value">{{item.label}}</div>
                </div>
                <Form class="h-login-box" ref="formLogin" :model="formLogin" :rules="ruleLogin">
                    <FormItem prop="account" >
                        <Input type="text" size="large" v-model="formLogin.account" placeholder="请输入用户名"></Input>
                    </FormItem>
                    <FormItem prop="password" >
                        <Input type="password" size="large" @keyup.enter.native="login('formLogin')"  v-model="formLogin.password" placeholder="请输入密码"></Input>
                    </FormItem>
                    <div class="ajFlex" style="margin-bottom: 20px">
                        <Checkbox style="font-size: 16px" v-model="autoLogin">自动登录</Checkbox>
                        <div class="aFlex" v-if="formLogin.loginType !== 'tenant'">
                            <a class="h-login-a" @click="handleRegist">新用户注册</a>
                            <a class="h-login-a" @click="handleForget">忘记密码?</a>
                        </div>
                    </div>
                    <div>
                        <Button type="primary" style="font-size: 22px" long size="large"  @click="login('formLogin')" >登录</Button>
                    </div>
                </Form>
            </div>
        </div>
        <Row :gutter="24" style="margin-bottom: 20px">
            <!-- <Col span="14" :xl="15"  >
                <Carousel class="h-carousel" v-model="carouselIndex"
                          radius-dot>
                    <CarouselItem>
                        <div @click="handlePicture(item.uuid)" class="h-carousel-item cFlex">
                            <img class="h-carousel-img" src="../../../assets/portal/portal-ad.png">
                            <div class="h-carousel-title">测试图片</div>
                        </div>
                    </CarouselItem>
                    <CarouselItem v-for="(item,index) in carouselImages" :key="index">
                        <div @click="handlePicture(item.uuid)" class="h-carousel-item cFlex">
                            <img class="h-carousel-img" :src="item.url">
                            <div class="h-carousel-title">{{item.name}}</div>
                        </div>
                    </CarouselItem>
                </Carousel>
            </Col> -->
            <!-- <Col span="10" :xl="9">
                <div class="h-login-wrapper">
                    <div class="h-login-top ajFlex">
                        <div class="h-login-item" :class="{active:formLogin.loginType==='tenant'}"
                             @click="formLogin.loginType='tenant'">主管部门</div>
                        <div class="h-login-item" :class="{active:formLogin.loginType==='qy'}"
                             @click="formLogin.loginType='qy'">企业登录</div>
                        <div class="h-login-item" :class="{active:formLogin.loginType==='gr'}"
                             @click="formLogin.loginType='gr'">个人登录</div>
                    </div>
                    <Form class="h-login-box" ref="formLogin" :model="formLogin" :rules="ruleLogin">
                        <FormItem prop="account" >
                            <Input type="text" size="large" v-model="formLogin.account" placeholder="请输入用户名"></Input>
                        </FormItem>
                        <FormItem prop="password" >
                            <Input type="password" size="large" @keyup.enter.native="login('formLogin')"  v-model="formLogin.password" placeholder="请输入密码"></Input>
                        </FormItem>
                        <div class="ajFlex" style="margin-bottom: 10px">
                            <Checkbox v-model="autoLogin">自动登录</Checkbox>
                            <a>忘记密码?</a>
                        </div>
                        <div>
                            <Button type="primary" long size="large"  @click="login('formLogin')" >登录</Button>
                        </div>
                    </Form>
                </div>
            </Col> -->
        </Row>
        <div style='padding: 0px 8% 30px'>
            <home-main></home-main>
        </div>
    </div>
</template>

<script>
    import {mapGetters,mapActions} from 'vuex';
    import HomeMain from './HomeMain.vue';
    import { getCarousel } from '@/api/homePage.js'

    export default {
        components: {
            'home-main':HomeMain,
        },
        data(){
            return {
                autoLogin:false,
                /* 轮播图 */
                carouselIndex:0,
                carouselImages:[],
                formLogin:{
                    account: '',
                    password: '',
                    loginType: 'tenant',
                },
                ruleLogin: {
                    account: [
                        { required: true, message: '请填写用户名!', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请填写密码!', trigger: 'blur' }
                    ]
                },
            };
        },
        computed: {
            ...mapGetters(['slideshowIp']),
        },
        created(){
            const redirect=this.$route.query.redirect;
            if (redirect) {
                this.clearCache();
            }
            getCarousel().then((res) => {
                if (res.status == 200 && Array.isArray(res.data)) {
                    this.carouselImages = res.data || []
                }
            })
        },
        mounted(){

        },
        watch: {

        },
        methods: {
            ...mapActions('users',['clearCache']),
            // 注册
            handleRegist(){
                this.$router.push({
                    name: this.formLogin.loginType + 'Register',
                    query:{
                        loginType:this.formLogin.loginType
                    }
                });
            },
            // 忘记密码
            handleForget(){
                this.$router.push({
                    name:'forgetPassword',
                    query:{
                        loginType: this.formLogin.loginType
                    }
                });
            },
            login(formLogin){
                this.$refs[formLogin].validate((valid) => {
                    if(valid){
                        this.$store.dispatch('users/userLogin',{
                            'account':this.formLogin.account,
                            'password':this.formLogin.password,
                            'loginType':this.formLogin.loginType,
                        }).then((res)=>{
                            if (res.data.success){
                                this.$router.push({ name: 'base' });
                            }else {
                                switch (res.data.errorMsg) {
                                    case 'password_error':
                                        this.$Message.error('用户名或密码错误!');
                                        break;
                                    case 'useraccount_error':
                                        this.$Message.error('用户名不存在!');
                                        break;
                                    default:
                                        this.$Message.error(res.data.errorMsg);
                                }
                            }
                        });
                    }
                });
            },

        }
    };
</script>

<style lang="less" scoped>
    .home-page {
        position: relative;
        .carousel {
            height: 500px;
            position: relative;
        }
    }
    /* 登录 */
    .h-login-wrapper{
        position: absolute;
        top: 60px;
        right: 8%;
        width: 455px;
        height: 360px;
        background-color: #ffffff;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
        border-radius: 8px;
    }
    .h-login-top{
        padding: 25px 25px 0 25px;
        border-bottom: 1px solid #EAEAEA;
    }
    .h-login-item{
        flex: 1;
        text-align: center;
        font-weight: 700;
        font-style: normal;
        font-size: 18px;
        line-height: 40px;
        color: #949494;
        border-bottom: 2px solid transparent;
        cursor: pointer;
        transition: color .3s ease-in-out;
    }
    .h-login-item.active{
        color: #0099FF;
        border-bottom-color: #0099FF;
    }
    .h-login-box{
        padding:30px 30px;
        font-size: 16px;
    }
    .h-login-a{
        margin-left: 10px;
    }
    .h-login-a:hover{
        text-decoration: underline;
    }
</style>



<style scoped>
    /* 轮播图 */
    .h-carousel-item{
        background-color: #ffffff;
        height: 500px;
        position: relative;
        /*cursor: pointer;*/
    }
    .h-carousel-title{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 40px;
        line-height: 40px;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        font-size: 20px;
        padding: 0 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .h-carousel-img{
        width: 100%;
        height: 100%;
    }

</style>
<style>
    /* 轮播图 */
    .h-carousel .ivu-carousel-dots-inside{
        right: 30px;
        bottom: 15px;
        width: auto;
    }
    .h-carousel .ivu-carousel-dots li {
        margin: 0 5px;
    }
    .h-carousel .ivu-carousel-dots li button.radius{
        width: 15px;
        height: 15px;
    }
    .h-carousel .ivu-carousel-dots li button{
        background: #fff;
    }
    .h-carousel .ivu-carousel-dots li.ivu-carousel-active>button.radius{
        width: 15px;
    }
</style>
